/**
 * @module platformReadyToSwitch
 */

/**
 * Platform Ready To Switch
*/

module.exports = function( Cookies ) {
    document.querySelector( '.ready-to-switch-form' ).addEventListener( 'submit', function( e ) {
        e.preventDefault();
        const platformUrlInput = this.querySelector( '.ready-to-switch-url' ).value;
        const type = this.querySelector( '.ready-to-switch-type' ).value;
        Cookies.destroy( 'source_url' );
        Cookies.destroy( 'target_url' );
        Cookies.create( `${ type }_url`, `${ encodeURIComponent( platformUrlInput ) }`, '1h', '/' );
        this.submit();
    } );
};
